import {mapState} from "vuex";
import api from '../../api'
import router from "../../router";
import {disposeResult} from '../../util/DisposeResult'
import {downFile} from '../../util/DownFile'

export default {
  name: 'enterFor',
  computed: mapState([
    'user',
  ]),

  data() {
    return {
      data: [],
      thesisLastStatus: '0',//筛选条件
      lastOptions: [{
        value: "0",
        label: "未终审",
      }, {
        value: "1",
        label: "已终审并拒绝",
      }, {
        value: "2",
        label: "已终审并通过",
      }, {
        value: "3",
        label: "已终审"
      }, {
        value: "4",
        label: "全部"
      }],
      oneColumn: false,
      twoColumn: false,
      threeColumn: false,
      dialogTitle: "",//弹出框的标题
      remarkDialog: false,
      remarkForm: {
        remark: "",
      },
      remarkRules: {
        remark: [
          {required: true, message: '请填写评语', trigger: 'submit'},
        ],
      },

      infoDialog: false,//详细信息
      endRemark: "",
      currentRow: {},
      consentOrRejectDisabled: false,//是否禁用查看详细信息的按钮
      isActive: false,//打开大文件时间较长给个遮罩

      teacherOptions: [],
      teacher: [],//选择的老师
      teacherRemark: "",//老师的评语
      suggest: "",//老师的建议

      readerDialog: false,//管理员审稿的dialog
      typeDisabled:true,//审核状态列是否隐藏
      educationList:[
        {
          value: 'NOT_APPLICABLE',
          label: '全部'
        }, {
          value: 'UNDERGRADE',
          label: '本科生'
        }, {
          value: 'MASTER',
          label: '研究生'
        },
      ],
      teamGrade: 'NOT_APPLICABLE',//学历筛选条件
      gradeList:[//NOT_APPLICABLE, GRADE_A, GRADE_B, GRADE_C, GRADE_D
        {
          value: 'NOT_APPLICABLE',
          label: '全部'
        },{
          value: 'GRADE_A',
          label: '通过A'
        }, {
          value: 'GRADE_B',
          label: '通过B'
        }, {
          value: 'GRADE_C',
          label: '通过C'
        }, {
          value: 'GRADE_D',
          label: '通过D'
        }
      ],//评级情况列表
      gradeStatus:'NOT_APPLICABLE',
      showGrade:false,//是否展示评级情况
      curRound:null,//当前比赛阶段
      approvalGrade:'NOT_APPLICABLE',//终稿通过时的评级情况
      teacherApprovalGrade:'',//当前老师的评级情况，用于展示
    }
  },
  methods: {

    changeThesisLast() {
      this.data = []
      this.typeDisabled = false
      this.showGrade = (this.thesisLastStatus == '2' && this.$store.state.curRound==3) ? true :false
      switch (this.thesisLastStatus) {
        case "0"://未终审
          this.getCurrentNoCheck()
          break;
        case "1"://已终审并拒绝
          this.getAllFinaledRefusedListByRoundNo()
          break;
        case "2"://终审并通过
          this.getAllFinaledApprovedListByRoundNo()
          break;
        case "3"://所有终审
          this.getAllFinaledListByRoundNo()
          break
        case "4"://全部
          this.getAllList()
          this.typeDisabled = true
          break
      }
    },

    /**
     * 选择老师变化的时候
     * @param value
     */
    onchange(value) {
      this.teacherRemark = ""
      this.suggest = ""
      this.teacherApprovalGrade = ""
      let row = this.currentRow
      let roundNo = router.app.$options.store.state.curRound
      for (let i = 0; i < row.refereeOpinionVos.length; i++) {
        if (row.refereeOpinionVos[i].refereeId === value && row.refereeOpinionVos[i].roundNo ===roundNo) {
          this.teacherRemark = row.refereeOpinionVos[i].refereeOpinionInfo
          this.teacherApprovalGrade = row.refereeOpinionVos[i].approvalGradeEnum
          switch(row.refereeOpinionVos[i].approvalGradeEnum){
            case 'GRADE_A':
              this.teacherApprovalGrade = '通过A'
              break;
            case 'GRADE_B':
              this.teacherApprovalGrade = '通过B'
              break;
            case 'GRADE_C':
              this.teacherApprovalGrade = '通过C'
              break;
            case 'GRADE_D':
              this.teacherApprovalGrade = '通过D'
              break;
            default:
              this.teacherApprovalGrade = ""
          }
          if (row.refereeOpinionVos[i].refereeStatusEnum === "APPROVED") {
            this.suggest = "建议通过"
          } else if (row.refereeOpinionVos[i].refereeStatusEnum === "REFUSED") {
            this.suggest = "建议不通过"
          }
          break
        }
      }
    },

    /**
     * 管理员审稿
     * @param row
     */
    checkArticle(row) {
      this.currentRow = row
      this.endRemark =""
      this.readerDialog = true
      this.approvalGrade = "NOT_APPLICABLE"
      let roundNo = router.app.$options.store.state.curRound
      for (let i = 0; i < row.refereeOpinionVos.length; i++) {
        if (row.refereeOpinionVos[i].roundNo === roundNo) {
          if (row.refereeOpinionVos[i].isFinal === 1) {
            this.consentOrRejectDisabled = true
            this.endRemark = row.refereeOpinionVos[i].refereeOpinionInfo
            break
          } else {
            this.consentOrRejectDisabled = false
          }
        }
      }
    },

    /**
     * 查看阶段的论文信息
     * @param row
     */
    viewWordData(row) {
      let number = router.app.$options.store.state.curRound
      let id = ""
      let fileName = row.teamName+"-"
      switch (number) {
        case 1:
          id = row.abstractFileName//1阶段
          fileName+=row.abstractOriginalName
          break
        case 2:
          id = row.briefFileName//2阶段
          fileName+=row.briefOriginalName
          break
        case 3:
          id = row.bodyFileName//三阶段
          fileName+=row.bodyOriginalName
          break
      }
      let vue = this
      this.isActive = true
      /* api.contribute.displayPDFOfManager(id).then(function (response) {
         if (response == null) {
           return null
         }
         const binaryData = [];
         binaryData.push(response.data);
         let url = window.URL.createObjectURL(new Blob(binaryData, {type: "application/pdf"}));
         window.open(url);
         vue.isActive = false
       })*/
      api.contribute.getWorksOfManager(id).then(function (response) {
        if (response == null) {
          return null
        }
        downFile(response,fileName,vue)
      })
    },

    /**
     * 查看老师审核信息
     * @param row
     */
    viewInfo(row) {
      this.endRemark = ""
      this.currentRow = row
      this.infoDialog = true
      let roundNo = router.app.$options.store.state.curRound
      let info = []
      this.teacherOptions = []
      this.teacher = ""
      this.teacherRemark=""
      this.suggest=""
      this.teacherApprovalGrade = ""
      for (let i = 0; i < row.refereeOpinionVos.length; i++) {
        if(row.refereeOpinionVos[i].isFinal===0 && row.refereeOpinionVos[i].roundNo ===roundNo){

          let obj = {}
          obj.value = row.refereeOpinionVos[i].refereeId
          obj.label = row.refereeOpinionVos[i].refereeTrueName
          this.teacherOptions.push(obj)
        }


        /*if (row.refereeOpinionVos[i].roundNo === roundNo) {
          if (row.refereeOpinionVos[i].isFinal === 1) {
            this.consentOrRejectDisabled = true
            this.endRemark = row.refereeOpinionVos[i].refereeOpinionInfo
            row.refereeOpinionVos.splice(i, 1)
            break
          } else {
            this.consentOrRejectDisabled = false
            info.push(row.refereeOpinionVos[i])
          }
        }*/
      }
      this.infoData = info
    },

    /**
     * 终审确定按钮
     * type 0通过  1拒绝
     */
    consentOrReject(type) {
      let vue = this
      let refereeStatusEnum = ""
      if (type === 0) {
        refereeStatusEnum = "APPROVED"
        if(this.curRound==3 && (!this.approvalGrade || this.approvalGrade=='NOT_APPLICABLE')){
          this.$message({
            showClose: true,
            duration: 2000,
            message: '请选择具体评级',
            type: 'warning'
          })
          return
        }
      } else {
        refereeStatusEnum = "REFUSED"
      }
      let thesisId = this.currentRow.id
      let refereeOpinionInfo = this.endRemark
      //只有终审时才传对应的值，否则传默认的NOT_APPLICABLE
      let approvalGradeEnum = this.curRound==3? this.approvalGrade : 'NOT_APPLICABLE'
      api.contribute.giveFinalRefereeOpinion(thesisId, refereeOpinionInfo, refereeStatusEnum,approvalGradeEnum).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          for (let i = 0; i < vue.data.length; i++) {
            if (vue.data[i].id === vue.currentRow.id) {
              vue.data.splice(i, 1)
            }
          }
          vue.readerDialog = false
        }
      })
    },

    /**
     * 隐藏列
     */
    hideColumn() {
      this.oneColumn = false
      this.twoColumn = false
      this.threeColumn = false
    },

    /**
     * 查询当前轮数未终审的数据
     */
    getCurrentNoCheck() {
      // this.thesisLastStatus = "0"
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllNotFinaledList(this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result,vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 管理员查询某轮所有已经终审结束的论文
     */
    getAllFinaledListByRoundNo() {
      // this.thesisLastStatus = "已终审"
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllFinaledListByRoundNo(0,this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result,vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 管理员获取某轮终审结束且通过的论文
     */
    getAllFinaledApprovedListByRoundNo() {
      // this.thesisLastStatus = "已终审并通过"
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllFinaledApprovedListByRoundNo(0,this.teamGrade,this.gradeStatus).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result,vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 管理员获取某轮终审结束且拒绝的论文
     */
    getAllFinaledRefusedListByRoundNo() {
      // this.thesisLastStatus = "1"
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllFinaledRefusedListByRoundNo(0,this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.data = disposeResult(result,vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 全部论文
     */
    getAllList() {
      // this.thesisLastStatus = "全部"
      let vue = this
      vue.tableLoading = true
      api.contribute.getAllList(0,this.teamGrade).then(function (response) {
        vue.tableLoading = false
        if (response === null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          let curRound = router.app.$options.store.state.curRound
          for (let i = 0; i < result.length; i++) {
            if (result[i].roundNo !== curRound) {
              result.splice(i, 1)
              i--
            }
          }
          vue.data = disposeResult(result,vue)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    }
  },

  created() {
    this.curRound = this.$store.state.curRound
    this.getCurrentNoCheck()
    this.typeDisabled = false
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/ThesisLast.js